/* global CONFIG */
import moment from 'moment'
import services from '../services'

export default {
  getTrasactions (VueApp, data, callback) {
    let self = this

    let trx = VueApp.$store.state.transactions
    let pageSize = trx.perPage
    let page = trx.currentPage
    if (data.isNext) { page++ } else { page-- }

    let filter = trx.filter
    let since = moment(filter.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00')
    let until = moment(filter.dateTo, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59')
    if (filter.date === 'all') {
      since = '2010-01-01 00:00'
      until = moment().add(10, 'years').format('YYYY-MM-DD 23:59')
    }

    let param = {
      token: VueApp.$store.state.session.sessionToken,
      pageSize: pageSize,
      pageNum: page,
      order: trx.sort.column,
      orderAsc: trx.sort.isDesc ? 0 : 1,
      since: since,
      until: until,
      search: filter.search,
      status: filter.status
    }
    if (filter.brand) param.brandId = filter.brand

    VueApp.$sdk.get('/transaction', param, res => {
      if (!res.error) {
        VueApp.$store.commit('transactions/setTotal', res.paging.totalItems)
        VueApp.$store.commit('transactions/setCurrentPage', page)

        let trx = []
        if (res.list.length) {
          res.list.forEach(function (value) {
            if (value.packageId) {
              trx.push(self.buildPackage(value))
            } else {
              trx.push(self.buildRsvp(value))
            }
          })
        }
        VueApp.$store.commit('transactions/setTransactions', trx)
      }
      callback(res)
    })
  },
  refreshTransaction (VueApp, data, callback) {
    let self = this

    let trx = VueApp.$store.state.transactions
    let pageSize = trx.perPage
    let page = trx.currentPage

    let filter = trx.filter
    let since = moment(filter.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00')
    let until = moment(filter.dateTo, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59')
    if (filter.date === 'all') {
      since = '2010-01-01 00:00'
      until = moment().add(10, 'years').format('YYYY-MM-DD 23:59')
    }

    VueApp.$sdk.get('/transaction', {
      token: VueApp.$store.state.session.sessionToken,
      pageSize: pageSize,
      pageNum: page,
      order: trx.sort.column,
      orderAsc: trx.sort.isDesc ? 0 : 1,
      since: since,
      until: until,
      search: filter.search,
      status: filter.status
    }, res => {
      if (!res.error) {
        VueApp.$store.commit('transactions/setTotal', res.paging.totalItems)
        VueApp.$store.commit('transactions/setCurrentPage', page)

        let trx = []
        if (res.list.length) {
          res.list.forEach(function (value) {
            if (value.packageId) {
              trx.push(self.buildPackage(value))
            } else {
              trx.push(self.buildRsvp(value))
            }
          })
        }
        VueApp.$store.commit('transactions/setTransactions', trx)
      }
      callback(res)
    })
  },
  exportTransactions (VueApp, data, callback) {
    let self = this

    let trx = VueApp.$store.state.transactions
    let pageSize = trx.perPage
    let page = trx.currentPage

    let filter = trx.filter
    let since = moment(filter.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00')
    let until = moment(filter.dateTo, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59')
    if (filter.date === 'all') {
      since = '2010-01-01 00:00'
      until = moment().add(10, 'years').format('YYYY-MM-DD 23:59')
    }

    VueApp.$sdk.get('/transaction', {
      token: VueApp.$store.state.session.sessionToken,
      pageSize: pageSize,
      pageNum: page,
      order: trx.sort.column,
      orderAsc: trx.sort.isDesc ? 0 : 1,
      since: since,
      until: until,
      search: filter.search,
      status: filter.status,
      export: true
    }, res => {
      if (!res.error) {
        let trx = []
        if (res.list.length) {
          res.list.forEach(function (value) {
            trx.push(self.buildExport(value))
          })
        }
        callback(trx)
      } else {
        callback(res)
      }
    })
  },
  buildRsvp (data) {
    let payment = data.payment
    let creditCard = payment.cancelFee ? 'N/A' : data.cardNumber
    if (data.isTerminal) {
      creditCard = 'Terminal'
    }
    let source = this.buildSource(data.deviceType)

    let trxData = {
      date: moment(data.datetime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY HH:mm:ss'),
      serviceArea: data.geofence.name,
      company: data.provider.businessName || '',
      providerId: data.provider.id,
      eventId: data.eventId || '',
      brandId: data.brandId,
      rsvpId: data.rsvpId || '000',
      id: data.id,
      pickupDate: moment(data.pickupTime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY HH:mm'),
      pickup: data.pickupLocation,
      dropoff: data.dropoffLocation,
      passenger: data.passengers,
      luggage: data.luggage,
      type: data.isAsap ? 'asap' : 'rsvp',
      serviceCode: data.serviceCode,
      serviceLabel: services.getServiceName(data.serviceCode),
      consumerId: data.consumer.id,
      firstName: data.consumer.firstName,
      lastName: data.consumer.lastName,
      email: data.consumer.email,
      mobile: data.consumer.phone,
      creditCard: creditCard,
      source: source,
      finalOffer: payment.offer || 0,
      chargedAmount: payment.charged || 0,
      bonus: payment.bonus || 0,
      promo: payment.credit || 0,
      cancelFee: payment.cancelFee || 0,
      bidAmount: payment.bidAmount,
      status: data.status,
      hasSubTransactionId: data.hasSubTransactionId,
      isReservationRefunded: data.isReservationRefunded,
      completed: data.completed,
      refundedAmount: data.refundedAmount,
      reservationState: data.reservationState,
      paymentURL: data.paymentURL,
      notes: data.notes,
      hasExtraStop: data.hasExtraStop,
      isCharter: data.isCharter
    }

    if (!CONFIG.useOldQuatation) {
      trxData.serviceType = {
        label: data.serviceType ? data.serviceType.label : '',
        color: data.serviceType ? data.serviceType.color : ''
      }
    }

    return trxData
  },
  buildPackage (data) {
    let payment = data.payment
    let source = this.buildSource(data.deviceType)

    let trxData = {
      date: moment(data.datetime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY HH:mm:ss'),
      serviceArea: data.geofence.name,
      company: data.provider.businessName || '',
      providerId: data.provider.id,
      eventId: data.eventId || '',
      pkgId: data.packageId,
      id: data.id,
      pickupDate: moment(data.pickupTime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY HH:mm'),
      pickup: data.pickupLocation,
      dropoff: data.dropoffLocation,
      passenger: data.passengers,
      luggage: data.luggage,
      type: data.isAsap ? 'asap' : 'rsvp',
      serviceCode: data.serviceCode,
      serviceLabel: services.getServiceName(data.serviceCode),
      consumerId: data.consumer.id,
      firstName: data.consumer.firstName,
      lastName: data.consumer.lastName,
      email: data.consumer.email,
      mobile: data.consumer.phone,
      creditCard: data.cardNumber,
      source: source,
      finalOffer: payment.offer || 0,
      chargedAmount: payment.charged || 0,
      bonus: payment.bonus || 0,
      promo: payment.credit || 0,
      cancelFee: payment.cancelFee || 0,
      bidAmount: payment.bidAmount,
      status: data.status,
      hasSubTransactionId: data.hasSubTransactionId,
      isReservationRefunded: data.isReservationRefunded,
      completed: data.completed,
      refundedAmount: data.refundedAmount,
      reservationState: data.reservationState,
      paymentURL: data.paymentURL,
      notes: data.notes,
      transactionType: data.transactionType
    }

    if (!CONFIG.useOldQuatation) {
      if (data.serviceType) {
        trxData.serviceType = {
          label: data.serviceType.label,
          color: data.serviceType.color
        }
      } else {
        trxData.serviceType = {
          label: services.getServiceName('shared'),
          color: '#555'
        }
      }
    }

    return trxData
  },
  buildSource (value) {
    switch (value) {
      case 'ww': return 'Web'
      case 'admin': return 'Admin'
      case 'android': return 'Android App'
      case 'ios': return 'iOS App'
      case 'provider': return 'Provider'
      default: return value
    }

    return ''
  },
  buildExport (data) {
    let rsvpId = this.convertBrand(data.brandId) + data.rsvpId
    let serviceType = services.getServiceName(data.serviceCode)
    let payment = data.payment
    let creditCard = payment.cancelFee ? 'N/A' : data.cardNumber
    let source = this.buildSource(data.deviceType)
    let provLicense = data.provider.accountType || ''

    if (data.packageId) {
      rsvpId = data.packageId
      serviceType = services.getServiceName('shared')
      source = 'PKG'
    }

    let trxData = {
      Date: moment(data.datetime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY'),
      'Booking Time': moment(data.datetime, 'YYYY-MM-DD@HH:mm:ss').format('HH:mm:ss'),
      'Pickup Time': moment(data.pickupTime, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY HH:mm'),
      'Service Area': data.geofence.name,
      'Prov ID': data.provider.id,
      'Prov License': provLicense.toUpperCase(),
      'Company': data.provider.businessName,
      'RSVP ID': rsvpId,
      'Invoice ID': data.eventId,
      'Service Type': serviceType,
      'First Name': data.consumer.firstName,
      'Last Name': data.consumer.lastName,
      'Credit Card': creditCard,
      'Email': data.consumer.email,
      'Mobile': data.consumer.phone,
      'Source': source,
      'Final Offer': payment.offer || 0,
      'Charge Amount': payment.charged || 0,
      'Refunded Amount': -Math.abs(data.refundedAmount) || 0,
      'Promo Used': payment.credit || 0,
      'Driver Payment': payment.driverPay || 0,
      'Bonus': payment.bonus || 0,
      'Cancel Fees': payment.cancelFee || 0,
      'Status': data.status,
      'Pickup Location': data.pickupLocation,
      'Dropoff Location': data.dropoffLocation
    }

    if (!CONFIG.useOldQuatation) {
      if (data.packageId) {
        trxData['Service Type'] = services.getServiceName('shared')
      } else {
        trxData['Service Type'] = data.serviceType.label
      }
    }

    return trxData
  },
  convertBrand (id) {
    let index = CONFIG.brands.findIndex(x => x.id === id)
    if (!id || index === -1) { return CONFIG.brands[0].code.toUpperCase() }

    return CONFIG.brands[index].code.toUpperCase()
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/transactions/index.js